import { Button, Tooltip } from "reactstrap";
import { useRef } from "react";
import WarningModal from "../WarningModal";
import type { TooltipProps } from "reactstrap";

type Props = {
  canSave: boolean;
  commonTooltipProps: Pick<TooltipProps, "placement" | "container" | "modifiers">;
  tooltipOpen: { save: boolean; clear: boolean; load: boolean; seasons: boolean; display: boolean };
  toggleTooltip: (k: keyof Props["tooltipOpen"]) => void;
  setShowOverwriteWarning: (b: boolean) => void;
  showOverwriteWarning: boolean;
  saveCustom: (ok: boolean) => void;
};

export function SaveButton({
  canSave,
  commonTooltipProps,
  tooltipOpen,
  toggleTooltip,
  setShowOverwriteWarning,
  showOverwriteWarning,
  saveCustom,
}: Props) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      {showOverwriteWarning && (
        <WarningModal
          item
          action={saveCustom}
          msg="Overwrite your previously saved custom settings - are you sure?"
          yesLabel="OK"
          dismissLabel="Cancel"
        />
      )}

      <Button
        innerRef={buttonRef}
        id="btnResultsSave"
        aria-label="Save Custom Result Settings"
        outline
        className={`border-0 shadow-none ${canSave ? "btn-hover-10" : ""}`}
        onClick={() => {
          buttonRef?.current?.blur();
          setShowOverwriteWarning(true);
        }}
        disabled={!canSave}
      >
        Save
      </Button>

      <Tooltip
        isOpen={tooltipOpen.save}
        target="btnResultsSave"
        toggle={() => toggleTooltip("save")}
        {...commonTooltipProps}
      >
        Save as custom settings
      </Tooltip>
    </>
  );
}
